import React from 'react'
import styled from 'styled-components'
import {getBorder} from 'utils/commons'
import {DragDrop} from 'common/components'
import {DROPBOX_UPLOAD_LIMIT} from 'consts/modules'

const StyledContainer = styled.div`
  ${({theme}) => ({
    border: getBorder(2, 'dashed', theme.gray_3),
    ':hover': {
      borderColor: theme.primary_5,
    },
  })}
  height: 100%;
  width: 100%;
  border-radius: 16px;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
`

export default function DropboxUploadDropzone({
  onLoadFiles,
}: {
  onLoadFiles: (files: File[]) => void
}) {
  return (
    <StyledContainer>
      <DragDrop
        icon="image"
        header="Drag & Drop Your Photos Here"
        description={`(Max. ${DROPBOX_UPLOAD_LIMIT} files)`}
        limit={DROPBOX_UPLOAD_LIMIT}
        onDrop={onLoadFiles}
        validator={() => null}
      />
    </StyledContainer>
  )
}
